export const supportStyle = {
	wrapper: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
		boxShadow: 'var(--box-shadow--1)',

		'@media (min-width: 1200px)': {
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},
	},

	title: {
		textAlign: 'center',
		marginBottom: '4px',
		fontWeight: 'bold',
	},

	accent: {
		color: 'var(--primary-500)',
	},

	afterTitle: {
		color: 'var(--neutral-300)',
		textAlign: 'center',
		marginBottom: '24px',
	},

	search: {
		position: 'relative',
		marginBottom: '24px',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '8px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-500)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			border: 0,
			background: 'var(--background-grey-op-50-1)',
		},
	},

	wrapperBtn: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px',
	},

	wrapperItem: {
		borderBottom: '1px solid var(--neutral-100)',
		boxShadow: 'none',
	},

	deacription: {
		padding: '12px',
	},

	buttonWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		background: 'var(--neutral-50)',
		padding: '12px',
		borderRadius: '8px',
	},

	text: {
		color: 'var(--neutral-300)',
	},

	button: {
		width: 'fit-content',
	},

	wrapperList: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0',
	},
};
